import PropTypes from 'prop-types';
import KTTooltip from '../KTTooltip';

export const KTLabelType = {
  default: '',
  rounded: 'label-rounded',
  square: 'label-square',
};

export const KTLabelSize = {
  default: '',
  small: 'label-sm',
  medium: 'label-md',
  large: 'label-lg',
  extraLarge: 'label-xl',
};

KTLabel.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(Object.values(KTLabelType)),
  isInline: PropTypes.bool,
  isPill: PropTypes.bool,
  isDotStyle: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(KTLabelSize)),
  additionalClassName: PropTypes.string,
  color: PropTypes.string,
  customBgColor: PropTypes.string,
  customTitleColor: PropTypes.string,
  additionalDescription: PropTypes.string,
};

function KTLabel({
  text = '',
  type = KTLabelType.default,
  isInline = true,
  isPill = true,
  isDotStyle = false,
  size = KTLabelSize.default,
  additionalClassName = '',
  color,
  customBgColor,
  customTitleColor,
  style,
  additionalDescription = '',
}) {
  return (
    <div>
      <KTTooltip
        text={additionalDescription}
        textHeader=""
        isHtmlContent
      >
        <span
          className={`
          label 
          ${type}
          ${isInline ? 'label-inline' : ''}
          ${isPill ? 'label-pill' : ''}
          ${isDotStyle ? 'label-dot' : ''}
          ${size}
          ${additionalClassName}
          ${additionalDescription ? 'text-underline' : ''}
        `}
          style={{
            backgroundColor: color ?? customBgColor ?? '',
            fontWeight: '600',
            color: customTitleColor,
            textDecoration: additionalDescription ? 'underline' : undefined,
            ...style,
          }}
        >
          {text}
        </span>
      </KTTooltip>
    </div>
  );
}

export default KTLabel;
